import React, { useCallback } from "react";

const LeftEllipsis = (props: { text: string }) => {
  const { text } = props;

  const handleCopy = useCallback(
    clipboardEvent => {
      if (
        !clipboardEvent.clipboardData ||
        !clipboardEvent.clipboardData.setData
      ) {
        return;
      }

      if (clipboardEvent.clipboardData.clearData) {
        clipboardEvent.clipboardData.clearData();
      }

      clipboardEvent.clipboardData.setData("text/plain", text);
      clipboardEvent.preventDefault();
    },
    [text]
  );

  return (
    <div onCopy={handleCopy} className="left-ellipses-text">
      {/* It's important to keep this character for the rtl to work properly */}
      {/* https://www.unicode-symbol.com/u/202A.html */}
      {`\u202a`}
      {text}
    </div>
  );
};

export default LeftEllipsis;
